module.exports = __webpack_public_path__ + "static/media/visa.4da420bf.svg";